import {
    CheckboxQuestion,
    EmojiChoiceQuestion,
    MultiChoiceQuestion,
    RankingQuestion,
    RatingQuestion,
} from './components';

import type { QuestionDefaults } from '../QuestionForm/QuestionForm';
import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

import { QuestionType } from '@/constants/QuestionType';

interface QuestionProps {
    question: ReviewQuestion;
    setQuestion: (question: ReviewQuestion) => void;
    // Competency-page-only default-choice overrides; undefined for other modules.
    questionDefaults?: QuestionDefaults;
}

export const Question = ({ question, setQuestion, questionDefaults }: QuestionProps) => {
    switch (question.questionType) {
        case QuestionType.CHECKBOX:
            return (
                <CheckboxQuestion
                    question={question}
                    setQuestion={setQuestion}
                    hideOtherOption={questionDefaults?.hideOtherOption}
                />
            );
        case QuestionType.EMOJI_CHOICE:
            return (
                <EmojiChoiceQuestion
                    question={question}
                    setQuestion={setQuestion}
                    satisfactionLabels={questionDefaults?.satisfactionLabels}
                />
            );
        case QuestionType.MULTI_CHOICE:
            return (
                <MultiChoiceQuestion
                    question={question}
                    setQuestion={setQuestion}
                    hideOtherOption={questionDefaults?.hideOtherOption}
                    emptyOptionCount={questionDefaults?.emptyOptionCount}
                />
            );
        case QuestionType.RATING_SCALE:
            return (
                <RatingQuestion
                    question={question}
                    setQuestion={setQuestion}
                    scaleFromLabel={questionDefaults?.scaleFromLabel}
                    scaleToLabel={questionDefaults?.scaleToLabel}
                />
            );
        case QuestionType.RANKING:
            return (
                <RankingQuestion
                    question={question}
                    setQuestion={setQuestion}
                />
            );
        case QuestionType.SECTION_TITLE:
        case QuestionType.YES_NO:
        default:
            // SECTION_TITLE / YES_NO / PLAIN_TEXT have no option builder
            return null;
    }
};
